module.exports = __webpack_public_path__ + "img/Wp_2089.686048b3.png";